/*!
 * first-touch-shop.js  v2
 * 初回接触ページ（ファーストタッチ）を受け取り、Shopifyの注文に記録する
 *
 * 設置: shop.yutokusan.jp（Shopifyテーマ assets/first-touch-shop.js）
 * 対になる処理: otakiagejinja.com 側の first-touch.js
 *
 * 動作
 *   1) otakiagejinja.com から引き継いだ ?ftlp= を優先して保存
 *   2) 引き継ぎも既存Cookieも無ければ shop 自身のURLを初回接触とする
 *   3) カート属性「起点ページ」に書き込む（CSVエクスポートで集計可能）
 *   4) 商品フォームに隠しプロパティ「_起点ページ」を差し込む  ← v2で追加
 *
 * なぜ 3 と 4 を併用するのか
 *   3 のカート属性は「今すぐ購入」「Apple Pay」などカートを経由しない
 *   購入では引き継がれず、約2割の注文で記録が欠落していた。
 *   4 は商品フォームそのものに乗るため、カートを通らない購入でも残る。
 *   ただしラインアイテム属性はCSVエクスポートに出力されないため、
 *   日常の集計は 3、取りこぼしの補完は 4（API取得）という役割分担とする。
 *
 * Cookie名 : ft_lp（90日・初回のみ書き込み、以降は上書きしない）
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'ft_lp';
  var COOKIE_DAYS = 90;
  var COOKIE_DOMAIN = '.yutokusan.jp';
  var PARAM = 'ftlp';
  var ATTR_KEY = '起点ページ';
  var PROP_NAME = 'properties[_起点ページ]';
  var SENT_FLAG = 'ft_lp_sent';
  var FORM_SELECTOR = 'form[action*="/cart/add"]';

  function getCookie(name) {
    try {
      var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return m ? decodeURIComponent(m.pop()) : null;
    } catch (e) {
      return null;
    }
  }

  function setCookie(name, value, days) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + days * 86400000);
      document.cookie = name + '=' + encodeURIComponent(value) +
        ';expires=' + d.toUTCString() +
        ';path=/;domain=' + COOKIE_DOMAIN + ';SameSite=Lax';
    } catch (e) {}
  }

  var firstTouch = null;

  try {
    firstTouch = getCookie(COOKIE_NAME);

    // --- 1) otakiagejinja.com からの引き継ぎを優先 ---------------
    var passed = null;
    try {
      passed = new URLSearchParams(location.search).get(PARAM);
    } catch (e) {}

    if (!firstTouch && passed) {
      firstTouch = passed;
      setCookie(COOKIE_NAME, firstTouch, COOKIE_DAYS);
    }

    // --- 2) 引き継ぎも既存も無ければ shop 自身を初回接触とする ----
    if (!firstTouch) {
      firstTouch = location.hostname + location.pathname;
      setCookie(COOKIE_NAME, firstTouch, COOKIE_DAYS);
    }

    // --- 3) カート属性へ書き込む（1セッション1回） ----------------
    var alreadySent = false;
    try {
      alreadySent = sessionStorage.getItem(SENT_FLAG) === firstTouch;
    } catch (e) {}

    if (!alreadySent && firstTouch) {
      var body = { attributes: {} };
      body.attributes[ATTR_KEY] = firstTouch;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function () {
        try { sessionStorage.setItem(SENT_FLAG, firstTouch); } catch (e) {}
      }).catch(function () {
        // 失敗しても購入フローには一切影響させない
      });
    }
  } catch (e) {
    // 何が起きてもストアフロントを壊さない
  }

  // ============================================================
  // 4) 商品フォームへの隠しプロパティ差し込み
  // ============================================================
  // カートを経由しない購入（今すぐ購入 / Apple Pay / Shop Pay 等）は
  // 商品フォームの内容をそのままチェックアウトへ送るため、
  // フォーム内に値を置いておけば確実に注文へ引き継がれる。

  function injectInto(form) {
    try {
      if (!form || !firstTouch) return;

      var existing = form.querySelector('input[name="' + PROP_NAME + '"]');
      if (existing) {
        // 値が変わるケースはほぼ無いが、念のため同期しておく
        existing.value = firstTouch;
        return;
      }

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = PROP_NAME;
      input.value = firstTouch;
      form.appendChild(input);
    } catch (e) {}
  }

  function injectAll() {
    try {
      var forms = document.querySelectorAll(FORM_SELECTOR);
      for (var i = 0; i < forms.length; i++) injectInto(forms[i]);
    } catch (e) {}
  }

  try {
    // 初期描画ぶん
    injectAll();

    // クイック追加・モーダル・カートドロワーなど、
    // あとからDOMに差し込まれるフォームにも対応する
    if (window.MutationObserver && document.body) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (!n || n.nodeType !== 1) continue;
            if (n.matches && n.matches(FORM_SELECTOR)) injectInto(n);
            if (n.querySelectorAll) {
              var inner = n.querySelectorAll(FORM_SELECTOR);
              for (var k = 0; k < inner.length; k++) injectInto(inner[k]);
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    // 送信直前の保険（監視が間に合わなかった場合に備える）
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.matches && f.matches(FORM_SELECTOR)) injectInto(f);
    }, true);

    // ダイナミックチェックアウトは submit を発火させない実装があるため、
    // フォーム内のポインタ操作時点でも差し込んでおく
    document.addEventListener('pointerdown', function (e) {
      try {
        var f = e.target && e.target.closest && e.target.closest(FORM_SELECTOR);
        if (f) injectInto(f);
      } catch (err) {}
    }, true);
  } catch (e) {}
})();